function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

export { addUniqueItem, removeItem };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/array.js
// module id = 200
// module chunks = 0